import ActionTypes from '../constants/ActionTypes';

const fetchContentViewPlans = (pointSystemId) => ({
  type: ActionTypes.CONTENT_VIEW_PLANS_FETCH,
  payload: {
    pointSystemId,
  },
});

fetchContentViewPlans.success = (pointSystemId, items) => ({
  type: ActionTypes.CONTENT_VIEW_PLANS_FETCH__SUCCESS,
  payload: {
    pointSystemId,
    items,
  },
});

fetchContentViewPlans.failure = (pointSystemId, error) => ({
  type: ActionTypes.CONTENT_VIEW_PLANS_FETCH__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const getOrCreateContentViewPlan = (pointSystemId, data) => ({
  type: ActionTypes.CONTENT_VIEW_PLAN_GET_OR_CREATE,
  payload: {
    pointSystemId,
    data,
  },
});

getOrCreateContentViewPlan.success = (item) => ({
  type: ActionTypes.CONTENT_VIEW_PLAN_GET_OR_CREATE__SUCCESS,
  payload: {
    item,
  },
});

getOrCreateContentViewPlan.failure = (pointSystemId, error) => ({
  type: ActionTypes.CONTENT_VIEW_PLAN_GET_OR_CREATE__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const updateContentViewPlan = (id, data) => ({
  type: ActionTypes.CONTENT_VIEW_PLAN_UPDATE,
  payload: {
    id,
    data,
  },
});

updateContentViewPlan.success = (item) => ({
  type: ActionTypes.CONTENT_VIEW_PLAN_UPDATE__SUCCESS,
  payload: {
    item,
  },
});

updateContentViewPlan.failure = (id, error) => ({
  type: ActionTypes.CONTENT_VIEW_PLAN_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

export default {
  fetchContentViewPlans,
  getOrCreateContentViewPlan,
  updateContentViewPlan,
};

